import { render, staticRenderFns } from "./PermissionEditorBlock.vue?vue&type=template&id=25d5dcd3&scoped=true"
import script from "./PermissionEditorBlock.vue?vue&type=script&lang=js"
export * from "./PermissionEditorBlock.vue?vue&type=script&lang=js"
import style0 from "./PermissionEditorBlock.vue?vue&type=style&index=0&id=25d5dcd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d5dcd3",
  null
  
)

export default component.exports